<div id="content">
  <div class="page-title d-flex align-items-center justify-content-between flex-wrap mb-3">
    <div class="d-flex align-items-center flex-wrap gap-2">
      <a mat-button routerLink="/employees/rrhh/job-vacancies">
        <mat-icon>arrow_back</mat-icon>
        Vacantes
      </a>
      <h1 class="mb-0">{{ page_title }}</h1>
    </div>
    <button mat-flat-button color="accent" type="button" (click)="openCreateDialog()">
      <mat-icon>add</mat-icon>
      Nueva plantilla
    </button>
  </div>

  <div class="bisual-table">
    <form class="card paginator" [formGroup]="filterForm">
      <mat-paginator
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="pageIndex"
        (page)="changePage($event)"
        style="margin-right: auto"
      ></mat-paginator>

      <mat-form-field>
        <input matInput type="text" formControlName="search" placeholder="Buscar..." />
        <button matSuffix mat-icon-button aria-label="Buscar" type="button">
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
    </form>

    <div class="bisual-table-container">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Nombre</th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="actions-cell">
            <div class="table-actions">
              <button mat-icon-button type="button" matTooltip="Editar" (click)="openEditDialog(element)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button type="button" matTooltip="Eliminar" (click)="deleteJobDescriptionTemplate(element)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
